import {
  ClockCircleOutlined,
  EyeOutlined,
  FileOutlined,
} from '@ant-design/icons';
import { AccordionItem } from '@mm/components';
import { ArrowUpDownIcon } from '@mm/icons/general/ArrowUpDownIcon';
import { ClickIcon } from '@mm/icons/general/ClickIcon';
import { SpeedometerIcon } from '@mm/icons/general/SpeedometerIcon';
import { ContactLeadScoring } from '@mm/state/interfaces/contacts';
import moment from 'moment';
import React from 'react';
import styles from './leadScoring.module.css';

type Props = {
  leadScoring?: ContactLeadScoring;
};

const LeadScoringContent = (props: { leadScoring: ContactLeadScoring }) => {
  const { leadScoring } = props;
  const duration = moment.duration(leadScoring.time);
  const hours = Math.floor(duration.asHours());
  return (
    <>
      <div className={styles.dataRow}>
        <ClockCircleOutlined />
        <div>Time on site</div>
        <div>
          {hours ? `${hours}:` : ''}
          {moment.utc(duration.asMilliseconds()).format('m:ss')}
        </div>
      </div>
      <div className={styles.dataRow}>
        <EyeOutlined />
        <div>Total Visits</div>
        <div>{leadScoring.sessions}</div>
      </div>

      <div className={styles.dataRow}>
        <FileOutlined />
        <div>Page Views</div>
        <div>{leadScoring.views}</div>
      </div>
      <div className={styles.dataRow}>
        <ArrowUpDownIcon />
        <div>Scroll depth</div>
        <div>{Math.floor(leadScoring.scroll / 96)} inches</div>
      </div>
      <div className={styles.dataRow}>
        <ClickIcon />
        <div>Clicks</div>
        <div>{leadScoring.clicks}</div>
      </div>
    </>
  );
};

export const LeadScoring = ({ leadScoring }: Props) => {
  if (!leadScoring) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      <AccordionItem
        icon={<SpeedometerIcon className="contact-details__header-icon" />}
        title="Customers.ai Lead Scoring"
        closeOnOutsideClick={false}
        className="contact-details__accordion-item"
        headingClassName="contact-details__accordion-item-heading"
      >
        <div className={styles.content}>
          {leadScoring.time ? (
            <LeadScoringContent leadScoring={leadScoring} />
          ) : (
            'No data available'
          )}
        </div>
      </AccordionItem>
    </div>
  );
};
